import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = []
	static values = { themeName: String, host: Boolean, currency: String, price: String, participants: Number, isEditing: Boolean }

  connect() {
  }

  select(e) {
    mixpanel.track('Selected Support Type', {
      'themeName': this.themeNameValue,
      'host': this.hostValue,
      'currency': this.currencyValue,
      'price': this.priceValue,
      'participants': this.participantsValue,
      'isEditing': this.isEditingValue
    });
  }
}
